import React, { useState } from "react";
import { addDefaultImg } from "../../utils/common-methods";

const ImagePreview = ({
  src,
  width = "auto",
  height = "auto",
  style = {},
  onDelete,
  imageId,
}) => {
  const [isModalOpen, setModalOpen] = useState(false);

  const handleDelete = () => {
    onDelete(imageId);
  };

  const handleImageClick = () => {
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
  };

  if (!src) {
    return <p>No image selected for preview.</p>;
  }

  return (
    <>
      <div
        style={{
          position: "relative",
          display: "inline-block",
          width,
          height,
          ...style,
        }}
      >
        <img
          src={src}
          alt="Preview"
          onClick={handleImageClick}
          style={{
            width: "100%",
            height: "100%",
            border: "1px solid #ccc",
            borderRadius: "5px",
            cursor: "pointer",
            marginBottom: "", // Indicate the image is clickable
          }}
          onError={addDefaultImg}
        />
        {imageId !== undefined && (
          <button
            onClick={handleDelete}
            style={{
              position: "absolute",
              top: "5px",
              right: "5px",
              backgroundColor: "#666666a6",
              color: "white",
              border: "none",
              borderRadius: "50%",
              width: "20px",
              height: "20px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
              padding:"0",
            }}
          >
            &times;
          </button>
        )}
      </div>

      {/* Modal */}
      {isModalOpen && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(0, 0, 0, 0.8)", // Backdrop
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 1000,
          }}
          onClick={closeModal} // Close modal on backdrop click
        >
          <div
            style={{
              position: "relative",
              backgroundColor: "white",
              borderRadius: "10px",
              overflow: "hidden",
            }}
            onClick={(e) => e.stopPropagation()} // Prevent closing on image click
          >
            <img
              src={src}
              alt="Full Preview"
              style={{
                display: "block",
                width: "100%",
                maxWidth: "1000px",
              }}
              onError={addDefaultImg}
            />
            <button
              onClick={closeModal}
              style={{
                position: "absolute",
                top: "10px",
                right: "10px",
                backgroundColor: "#666666a6",
                color: "white",
                border: "none",
                borderRadius: "50%",
                width: "30px",
                height: "30px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
              }}
            >
              &times;
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default ImagePreview;
